module.exports = __webpack_public_path__ + "static/media/logo-jim-moroney-hd.e96553f5.png";